import {
  HeadingSize,
  HeadingTag,
  Headline,
} from "@ldp-web/component-library/ui/molecules/headline";
import React, { FC } from "react";
import { MdInfoOutline } from "@react-icons/all-files/md/MdInfoOutline";
import { WrapperSection } from "@ldp-web/component-library/ui/atoms/section";
import { TextAlignmentUppercase } from "@ldp-web/component-library/types/common.types";

/** props for Headline Component */
export interface IHeadlineComponentProps {
  /** headline */
  headline: {
    text: string;
    alignment: TextAlignmentUppercase;
    headerType: HeadingTag;
    headlineSize: HeadingSize;
  };
  /** id of component */
  id?: string;
}

/** Renders Headline component */
export const HeadlineComponent: FC<IHeadlineComponentProps> = ({
  headline,
  id,
}) => {
  const { alignment, text, headerType = "h1", headlineSize = 1 } = headline;

  return (
    <WrapperSection id={id}>
      <Headline
        alignment={alignment}
        headlineSize={headlineSize}
        paragraphLeftIcon={MdInfoOutline}
        headingTag={headerType}
        title={text}
      />
    </WrapperSection>
  );
};

export default HeadlineComponent;
